import {JWT} from "../constants/local-storage";
import {STRINGIFY} from "../constants/general-constants";
import {AREA_UNIT_SQM} from "../constants/general-constants";

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];



// GET OBJECT FROM AJAX ***********************************************

const getObjectFromAjax = (ajax, setObject, thenDoFunction) => {
	
  fetch(ajax, {
  	method:"GET",
  	headers:{
  		'Authorization': localStorage.getItem(JWT)
  	}
  })
  .then(response => {
  		if(!response.ok){
  			
  		}
  		else{
  			return response;
  		}
  })
  .then(result => result.json())
  .then(data => {
  	
  	try{
  		if(setObject){
  			setObject(data);
  		}
  		if(thenDoFunction){
  			
  			thenDoFunction(data);
  		}
  	}
  	catch(e){
  		
  		console.log(e);
  		
  	}
  })
  .catch(error => {
  	
  	console.log(error);
  })
};




// GET ARRAY FROM AJAX ***********************************************

const getArrayFromAjax = (ajax, setArray, thenDoFunction) => {
  fetch(ajax, {
  	method:"GET",
  	headers:{
  		'Authorization': localStorage.getItem(JWT)
  	}
  })
  .then(response => {
  		if(!response.ok){
  			//console.log(response);
  		}
  		else{
  			return response;
  		}
  })
  .then(result => result.json())
  .then(data => {
  	
  	try{
  		let tempArray = [];
  		for(let i=0; i<data.length; i++){
  			tempArray.push(data[i]);
  		}
  		if(setArray){
  			setArray(tempArray);
  		}
  		
  		if(thenDoFunction){
  			thenDoFunction(data);
  		}
  	}
  	catch(e){
  		console.log(e);
  		
  	}
  })
  .catch(error => {
  	console.log(error);
  })
};

// SUBMIT AJAX ***********************************************

const submitAjax = (ajax, postObject, thenDoFunction, stringify, errorFunction) => {
		
	 let postBody = {};
	 let headers = {};
	 if(stringify && stringify === STRINGIFY){
	 		postBody = JSON.stringify(postObject);
	 	  headers = {
    		'Authorization': localStorage.getItem(JWT),
    		'Content-Type':'application/json'
    	};
	 }
	 else{
	 		postBody = postObject;
	 		headers = {
    		'Authorization': localStorage.getItem(JWT)
    	};
	 }
	 
	 
	 fetch(ajax, {
    	method:"POST",
    	headers:headers,
    	body:postBody
    })
	  .then(async response => {
	  	const data = await response.json();
	  	if(thenDoFunction){
	  			thenDoFunction(data);
	  	}
	  })
	  .catch(error => {
	  	console.log(error);
	  	if(thenDoFunction){
	  		thenDoFunction({});
	  	}
	  });
  	
};

// SUBMIT AJAX NO CORS***********************************************

const submitAjaxNoCors = (ajax, postObject, thenDoFunction, stringify, errorFunction) => {
		
	 let postBody = {};
	 let headers = {};
	 if(stringify && stringify === STRINGIFY){
	 		postBody = JSON.stringify(postObject);
	 	  headers = {
    		'Authorization': localStorage.getItem(JWT),
    		'Content-Type':'application/json'
    	};
	 }
	 else{
	 		postBody = postObject;
	 		headers = {
    		'Authorization': localStorage.getItem(JWT)
    	};
	 }
	 
	 
	 fetch(ajax, {
    	method:"POST",
    	headers:headers,
    	mode: 'no-cors',
    	body:postBody
    })
	  .then(async response => {
	  	const data = await response.json();
	  	if(thenDoFunction){
	  			thenDoFunction(data);
	  	}
	  })
	  .catch(error => {
	  	console.log(error);
	  	if(thenDoFunction){
	  		thenDoFunction({});
	  	}
	  });
  	
};

// SUBMIT AJAX WITH ID***********************************************

const submitAjaxWithId = (ajax, postObject, thenDoFunction, stringify, errorFunction, id) => {
		
	 let postBody = {};
	 let headers = {};
	 if(stringify && stringify === STRINGIFY){
	 		postBody = JSON.stringify(postObject);
	 	  headers = {
    		'Authorization': localStorage.getItem(JWT),
    		'Content-Type':'application/json'
    	};
	 }
	 else{
	 		postBody = postObject;
	 		headers = {
    		'Authorization': localStorage.getItem(JWT)
    	};
	 }
	 
	 
	 fetch(ajax, {
    	method:"POST",
    	headers:headers,
    	body:postBody
    })
	  .then(() => {
	  	if(thenDoFunction){
	  			thenDoFunction(id);
	  	}
	  })
	  .catch(error => {
	  	thenDoFunction(id);
	  });
  	
};

// GET USER
 const getUser = (callback) => {
	
		const thisUrl = "/resolutionsoftwareplatform/getuser";

		
    fetch(thisUrl, {
    	method:"GET",
	  	headers:{
	  		'Authorization': localStorage.getItem(JWT),
	  		'Content-Type':'application/json'
	  	}
    })
    .then(response => {
  		if(!response.ok){
  			console.log(response);
  		}
  		else{
  			return response;
  		}
  })
  .then(result => result.json())
  .then(data => {
  	callback(data);
  })
  .catch(error => {
  	console.log("ERROR");
  	console.log(JSON.stringify(error));
  })
 };
 
 // CHECK USER
 const checkUser = () => {
	
		const thisUrl = "/resolutionsoftwareplatform/getuser";
	
		
    fetch(thisUrl, {
    	method:"GET",
	  	headers:{
	  		'Authorization': localStorage.getItem(JWT),
	  		'Content-Type':'application/json'
	  	}
    })
    
  .then(result => result.json())
  .then(data => {
  	if(data.id){
  		return  true;
  	}
  	else{
  		return false;
  	}
  })
  .catch(error => {
  	return false;
  });
  
  
 };
 
 // POPULATE ARRAY FROM EMPTY
 
 const populateArrayFromEmpty = (data) => {
 	 let tempArray = [];
 	 for(let i=0; i<data.length; i++){
 	 	 tempArray.push({
 	 	 	 id:data[i].id,
 	 	 	 name:data[i].name
 	 	 });
 	 }
 	 return tempArray;
 };
 
 //FORMAT NUMBER
 const formatNumber = (x, decimals) => {
 		
 		try{
   		return x.toFixed(decimals).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
   	}
   	catch(e){
   		return x;
   	}
}


//SET FILE SOURCE
const getFileSource = (fileUrl, setSource, thenDoFunction) => {
	
		fetch(fileUrl, {
	    	method:"GET",
	    	headers:{
	    		'Authorization': localStorage.getItem(JWT)
	    	}
	    })
	    .then(result => result.blob())
	    .then(result => {
	    	
	    	setSource(URL.createObjectURL(result));
	    	if(thenDoFunction){
	    		thenDoFunction();
	    	}
	    });
	};
	
	//DOWNLOAD FILE
const downloadFile = (fileName, fileUrl, thenDoFunction) => {
		fetch(fileUrl, {
	    	method:"GET",
	    	headers:{
	    		'Authorization': localStorage.getItem(JWT)
	    	}
	    })
	    .then(result => result.blob())
	    .then(result => {
	    	const aElement = document.createElement('a');
      	aElement.setAttribute('download', fileName);
      	const href = URL.createObjectURL(result);
      	aElement.href = href;
      	aElement.setAttribute('target', '_blank');
      	aElement.click();
      	URL.revokeObjectURL(href);
	    	if(thenDoFunction){
	    		thenDoFunction();
	    	}
	    })
	    .catch((error) => {
			  alert(error);
			});
	};

const vividColors = [
	'#E14E2C', 
	'#D65EFF', 
	'#73B017', 
	'#495EFF', 
	'#7153CA', 
	'#2CAAE1',
	'#bb9900'
];

//GET VIVID COLOR
const getVividColor = (address) => {
	return vividColors[address%vividColors.length];
};

const setPieAndTrendData = (labelData, setPieDataFunction, setTrendDataFunction, setTrendGraphsFunction) => {
		let pieData = [];
		let trendData = [];
		let trendGraphs = [];
		
		for(let i=0; i<labelData.length; i++){
			try{
				pieData.push({
					id:labelData[i].id,
					label:labelData[i].name,
					value:Math.round(Math.random()*100) + 3000,
					color:functions.getVividColor(i)
				});
			}
			catch(e){
				console.log(e);
			}
		};
		
		
		let years = ['2017', '2018', '2019', '2020'];
		
		for(let i=0; i<years.length; i++){
			for(var j=0; j<months.length; j++){
				
				let thisDataItem = {
					label:months[j] + ' ' + years[i]
				};
				
				for(let k=0; k<labelData.length; k++){
					thisDataItem[labelData[k].id] = Math.round(Math.random()*1000);
				}
				
				trendData.push(thisDataItem);
			}		
		}
		
		
		for(let i=0; i<labelData.length; i++){
			trendGraphs.push({
				title:labelData[i].name,
				keyColumn:labelData[i].id
			})	
		}
		
		setPieDataFunction(pieData);
		setTrendDataFunction(trendData);
		setTrendGraphsFunction(trendGraphs);
	};
	
const	getThisMonthDisplay = () => {
	let today = new Date();
	return months[today.getMonth()] + ' ' + (today.getYear() + 1900);
};

	const parseDate = (date) => {
		try{
			let day = date.getDate();
			let month = date.getMonth() + 1;
			let year = date.getYear() + 1900;
			if(day < 10){
				day = "0" + day;
			}
			if(month < 10){
				month = "0" + month;
			}
			return day + "/" + month + "/" + year;
			
		}
		catch(e){
			return "";
		}
	}
	
	const formatDate = (input) => {
		try{
			return input.split('-')[2] + '/' + input.split("-")[1] + '/' + input.split("-")[0];
		}
		catch(e){
			return '';
		}
	};
	
	const parseDateFromJava = (input) => {
		
		return input;
	};
	
	const parseDateFromDatabase = (input) => {
		if(input){
			return input.substring(0, input.indexOf("T"));
		}
		else{
			return "";
		}
	};
	
	const convertToJavaDate = (date) => {
		let returnDate = new Date();
		
		try{
			date.setYear(parseInt(date.split("-")[0]) - 1900);
			date.setMonth(parseInt(date.split("-")[1]) - 1);
			date.setDate(parseInt(date.split("-")[2]));
		}
		catch(e){}
		
		return returnDate;
	};
	
	const limitStringLength = (input, checkLength) => {
		if(input.length > checkLength){
			return input.substring(0, checkLength) + '...';
		}
		else{
			return input;
		}
	};
	
	const getRandomArrayElement = (input) => {
		return input[Math.round(Math.random()*(input.length - 1))];
	};
	
	const convertArea = (area, unitAreaId) => {
		let returnArea = area;
		
		try{
			if(unitAreaId === AREA_UNIT_SQM){
				
				returnArea = Math.round(parseFloat(area)*0.092903);
			}
			else{
				returnArea = Math.round(area);
			}
			
		}
		catch(e){}
		return returnArea;
	};
	
	const getIsEditor = (inputRoles) => {
		try{
			let roles = ["SUPERADMIN", "ADMIN", "EDITOR"];
			let returnVal = false;
			
			for(let i=0; i<roles.length; i++){
				if(inputRoles.includes(roles[i])){
					returnVal = true;
				}
			}
			return returnVal;
		}
		catch(e){
			return false;
		}
		
	};
	
	const checkIsImage = (filename) => {
		let imageExtensions = [
			"JPG",
			"PNG",
			"GIF",
			"JPEG",
			"BMP",
			"WEBP"
		];
		
		let isImage = false;
		
		for(let i=0; i<imageExtensions.length; i++){
			if(filename.toUpperCase().indexOf(imageExtensions[i]) > -1){
				isImage = true;
			}
		}
		
		return isImage;
		
	};


export const functions = {
	getObjectFromAjax: getObjectFromAjax,
	getArrayFromAjax: getArrayFromAjax,
	submitAjax: submitAjax,
	submitAjaxNoCors: submitAjaxNoCors,
	submitAjaxWithId: submitAjaxWithId,
	getUser: getUser,
	populateArrayFromEmpty:populateArrayFromEmpty,
	formatNumber:formatNumber,
	formatDate:formatDate,
	getVividColor:getVividColor,
	getFileSource:getFileSource,
	downloadFile:downloadFile,
	setPieAndTrendData :setPieAndTrendData ,
	getThisMonthDisplay:getThisMonthDisplay,
	parseDate:parseDate,
	parseDateFromJava:parseDateFromJava,
	parseDateFromDatabase:parseDateFromDatabase,
	checkUser:checkUser,
	limitStringLength:limitStringLength,
	getRandomArrayElement:getRandomArrayElement,
	convertToJavaDate:convertToJavaDate,
	convertArea:convertArea,
	getIsEditor:getIsEditor,
	checkIsImage:checkIsImage
}

